export enum GenericItemTypeEnum {
	TEXT = 'TEXT',
	IMAGE = 'IMAGE',
	DIVIDER = 'DIVIDER',
	DICTIONARY = 'DICTIONARY',
}
